// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-table-wrap .pagination[data-v-0180709c]{text-align:right;margin-top:10px}.my-table-wrap .el-table--border th.gutter[data-v-0180709c]:last-of-type{width:16px!important}.network-download-dialog .el-dialog__body[data-v-0180709c]{padding-top:0}", ""]);
// Exports
module.exports = exports;
